// Operaciones & RRHH — dashboard de métricas operativas.
// Usa OperationsDashboard (componente) que carga datos vía /api/operaciones.
import OperationsDashboard from '../components/OperationsDashboard'

export default function Operaciones() {
  return <OperationsDashboard />
}
